var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDuplicate = function SvgDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M37 21a1 1 0 0 1 1 1v14h12a1 1 0 1 1 0 2H38v12a1 1 0 1 1-2 0V38H22a1 1 0 1 1 0-2h14V22a1 1 0 0 1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 10a2 2 0 0 0-2 2v48a2 2 0 0 0 2 2h6v6a2 2 0 0 0 2 2h48a2 2 0 0 0 2-2V20a2 2 0 0 0-2-2h-6v-6a2 2 0 0 0-2-2zm48 52a2 2 0 0 0 2-2V20h6v48H20v-6zm0-50H12v48h48z",
    clipRule: "evenodd"
  })));
};
export default SvgDuplicate;